
import SettingsIcon from '@mui/icons-material/Settings';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';


const StoreMgmt = {
  id: '100',
  title: 'Store Mgmt',
  type: 'group',
  role:'PHARMA_OMS_STORE,PHARMA_OMS_DESIGNER',
  children: [
    {
                  id: 'tasklist',
                  title: 'My Task(s)',
                  type: 'item',
                  url: '/',
                  bottomMenu:'MYTASKS',
                  icon: FormatListNumberedIcon
                },
                {
                  id: 'collaborationboard',
                  title: 'Collaboration Board',
                  type: 'item',
                  url: '/',
                  bottomMenu:'COLLABORATION_BOARD',
                  icon: FormatListNumberedIcon
                },
    // {
    //       id: 'storemanagament',
    //       title: 'Packaing Material Order(s)',
    //       type: 'item',
    //       url: '/',
    //       bottomMenu:'PMORDERS',
    //       icon: FormatListNumberedIcon
    //     },
  ]
};

export default StoreMgmt;